var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageWrapper',{attrs:{"pageTitle":"Feature Flags"}},[_c('NebulaGridRow',{attrs:{"type":"flex"}},[_c('NebulaColumn',{attrs:{"columns":12}},_vm._l((Object.keys(_vm.flags)),function(flag,idx){return _c('div',{key:`${idx}-flag`},[_c('p',[_vm._v(_vm._s(flag)+": "+_vm._s(_vm.flags[flag]))])])}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }